<style lang="less" scoped>
</style>
<template>
  <div>
    <!--<countdown date="February 21, 2021">
      <img src="//rest.ahlpoker.com/image/get/324"/>
    </countdown>-->
    <div class="column is-12 instagram-block is-paddingless">
      <h3 class="has-text-centered">
        Instagram <a
          href="https://www.instagram.com/ahl_poker/"
          target="_blank"
        >#ahlpoker</a>
      </h3>
      <div class="instagram">
        <iframe src="https://cdn.lightwidget.com/widgets/420169ba048f5a28a4fc9dfa299f91d0.html" scrolling="no" allowtransparency="true" class="lightwidget-widget" style="width:100%;border:0;overflow:hidden;height:100%"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
  import Countdown from '../helpers/Countdown'
  export default {
    name: 'Instagram',
    components: {
      Countdown
    },
    data () {
      return {
        lightwidget: '<scr' + 'ipt src="//lightwidget.com/widgets/lightwidget.js">' + '</scr' + 'ipt>'
      }
    },
    computed: {},
    mounted() {
    },
    methods: {}
  }
</script>
